import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { PolicyContentService } from '../../services/policy-content.service';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-error-uploaded',
    templateUrl: './error-uploaded.component.html',
    styleUrls: ['./error-uploaded.component.scss'],
    imports: [MatIconButton, MatIcon, ReactiveFormsModule, FormsModule, MatButton, NgIf, MatDialogContent, MatDialogActions]
})
export class ErrorUploadedComponent implements OnInit, OnDestroy {
private destroy$ = new Subject<void>();
content:any;
customMessage?: string;
customTitle?: string;
showViewBtn: boolean = false;
failedCount?: number;
totalRecords?: number;
showErrorIcon: boolean = false;
ctaText?: string;
policyContent:any;
constructor(
  private readonly bookingContentService: BookingContentService, private contentService:ContentService, 
  private travelerDataLayer: TravelerManagement,
  public dialogRef: MatDialogRef<ErrorUploadedComponent>,
  @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private readonly policyContentService: PolicyContentService
){
  if (data) {
    this.customMessage = data.message;
    this.customTitle = data.title;
    this.showViewBtn = !!data.showViewBtn;
    this.failedCount = data.failedCount;
    this.totalRecords = data.totalRecords;
    this.showErrorIcon = !!data.showErrorIcon;
    this.ctaText = data.ctaText;
  }
}

viewDetails() {
  this.travelerDataLayer.someUserUploadError(`${this.failedCount} out of ${this.totalRecords} profiles were not uploaded.`);
  this.dialogRef.close({ action: 'view' });
}

closeDialog() {
  this.dialogRef.close();
}

getFailedProfilesText(): string {
  const template = this.content?.['b2b.managetraveler.nooferrorfiles']
    || '{nooferrorfiles} out of {totalfiles} profiles were not uploaded.';
  return template
    .replace('{nooferrorfiles}', String(this.failedCount ?? 0))
    .replace('{totalfiles}', String(this.totalRecords ?? 0));
}
ngOnInit(){
  this.travelerDataLayer.fileError(); // GTM call
  this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
    this.content = res;
  });

  this.policyContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.policyContent = res;
    });
  
}
ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
